import { Pipe, PipeTransform } from '@angular/core';
import { ITEMTYPE, ROWPOSITION } from 'src/app/shared/components/field-item/field-item.model';
import { FieldItemRowService } from '../services/row/row.service';
import { SIZE } from '../components/field-item-row/row.model';

@Pipe({
  name: 'maxMinFieldWidth',
  standalone: true
})
export class MaxFieldWidthPipe implements PipeTransform {

   constructor (private sFieldItemRow: FieldItemRowService) {}

   transform (fieldType: string, size: string, isRowOrColumn?: ROWPOSITION): string {
      switch (fieldType) {
         case ITEMTYPE.titleOne: return SIZE.PERCENT100; 
         case ITEMTYPE.titleSecond: return SIZE.PERCENT100; 
         case ITEMTYPE.divider: return SIZE.PERCENT100;
         case ITEMTYPE.text: return SIZE.PERCENT100;
         case ITEMTYPE.allToggleFunction: return SIZE.PERCENT100;
         case ITEMTYPE.imgText: return SIZE.PERCENT100;
         case ITEMTYPE.textInput: return size;
         case ITEMTYPE.toggle: return size;
         case ITEMTYPE.combofield: return size;
         case ITEMTYPE.date: return size;
         case ITEMTYPE.download: return size;
         case ITEMTYPE.email: return size;
         case ITEMTYPE.legend: return "";
         case ITEMTYPE.link: return size;
         case ITEMTYPE.number: return size;
         case ITEMTYPE.row: return "";
         default: return this.sFieldItemRow.isRowOrColumn(fieldType, isRowOrColumn) == ROWPOSITION.row ? size : SIZE.PERCENT100;
      } 
   }
}